import { ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { cn } from 'src/utils/className';

interface BarChartProps {
  data: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string;
      borderWidth: number;
      borderRadius: number;
    }>;
  };
  options: ChartOptions<'bar'>;
  conversionPercentages?: string[];
  className?: string;
}

export const BarChart = ({
  data,
  options,
  conversionPercentages = [],
  className = '',
}: BarChartProps) => {
  return (
    <div className={cn('h-[28rem] relative', className)}>
      <Bar data={data} options={options} />

      {/* Conversion percentages overlay */}
      {conversionPercentages.length > 0 && (
        <div className="absolute top-16 left-0 right-0 flex justify-between px-12">
          {conversionPercentages.map((percentage, index) => (
            <div key={index} className="text-center">
              <div className="text-xs text-neutral-500 mb-1">{percentage}</div>
              <div className="w-8 h-px bg-neutral-300"></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
